import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { copyGroups } from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/constants'
import {
  allCopies,
  getCopiesByGroup,
  getTabsWithErrors,
} from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/helpers'

import { getFirstCopyKey } from './helpers'

const useCopiesPageTabs = ({ language, errors, onChangeIsActive }) => {
  const { t } = useTranslation()
  const [selectedTab, setSelectedTabState] = useState(copyGroups.blockedProducts)
  const [activePreview, setActivePreview] = useState(getFirstCopyKey(copyGroups.blockedProducts))
  const [previewLanguage, setPreviewLanguage] = useState(language)

  const setSelectedTab = newTab => {
    setSelectedTabState(newTab)
    setActivePreview(getFirstCopyKey(newTab))
  }

  const handleChangeIsActive = (checked, fullKey) => {
    onChangeIsActive(checked, fullKey)
    if (!checked) setPreviewLanguage(language)
    if (selectedTab !== copyGroups.misc) setActivePreview(fullKey)
  }

  const copies = getCopiesByGroup(selectedTab)
  const tabs = getTabsWithErrors(t, errors, allCopies)

  return {
    selectedTab,
    setSelectedTab,
    activePreview,
    setActivePreview,
    previewLanguage,
    setPreviewLanguage,
    handleChangeIsActive,
    tabs,
    copies,
  }
}

export default useCopiesPageTabs
